import React from "react";

import * as S from "./styled";

const ModalContent = () => (
  <S.ModalContainer>
    <S.ModalTop>
      <S.ModalHeaderContainer>
        <S.ModalHeader>
          Tips for Searching With a Housing Voucher, Like Section 8
        </S.ModalHeader>
        <S.FairHousingImage alt="" aria-hidden="true"></S.FairHousingImage>
      </S.ModalHeaderContainer>
    </S.ModalTop>
    <S.BodyWrapper>
      <S.ModalParagraphTitle>Know Your Rights</S.ModalParagraphTitle>
      <S.ModalText>
        Go into your search knowing your rights. It&apos;s illegal in New York
        and New Jersey for landlords to discriminate against tenants who use a
        lawful source of income, like Section 8, to pay rent.
      </S.ModalText>
      <S.ModalParagraphTitle>Focus Your Search</S.ModalParagraphTitle>
      <S.ModalText>
        Focus on homes that are likely affordable with your voucher by using our
        price range tool. Use your voucher allowance, or payment standard, as a
        max rent price. Even if you can afford more, it&apos;s a good place to
        start.
      </S.ModalText>
      <S.ModalParagraphTitle>Document Your Exchanges</S.ModalParagraphTitle>
      <S.ModalText>
        Though illegal, voucher discrimination happens. Be prepared by
        documenting your exchanges with agents and landlords. To report it in
        NYC, call 311 and ask for the Commission on Human Rights. In NJ, call
        the Division on Civil Rights at 866-405-3050.
      </S.ModalText>
      <S.MoreTipsLink
        href="https://streeteasy.com/blog/section-8-apartments-nyc/"
        target="_blank"
      >
        {" "}
        SEE MORE TIPS ON OUR BLOG
      </S.MoreTipsLink>{" "}
    </S.BodyWrapper>
  </S.ModalContainer>
);
export default ModalContent;
